






















































































































































































































import { Component, Vue} from "vue-property-decorator";
import TextHeaderSmall from "@/components/Common/TextHeaderSmall.vue";
import Clients from "@/components/Home/Clients.vue";
import Reviews from "@/components/Home/Reviews.vue";

@Component({
    components: {
        TextHeaderSmall,
        Clients,
        Reviews,
    }
})
export default class ClientsPage extends Vue{
    private activeImage: string = "";
    private dialogVisible: boolean = false;

}
